export const color = {
    "callout": {
        "text": {
            "info": "var(--colorCalloutTextInfo)",
            "success": "var(--colorCalloutTextSuccess)",
            "warning": "var(--colorCalloutTextWarning)",
            "danger": "var(--colorCalloutTextDanger)",
            "feature": "var(--colorCalloutTextFeature)",
            "default": "var(--colorCalloutTextDefault)",
            "body": "var(--colorCalloutTextBody)"
        },
        "icon": {
            "info": "var(--colorCalloutIconInfo)",
            "success": "var(--colorCalloutIconSuccess)",
            "warning": "var(--colorCalloutIconWarning)",
            "danger": "var(--colorCalloutIconDanger)",
            "feature": "var(--colorCalloutIconFeature)",
            "default": "var(--colorCalloutIconDefault)"
        },
        "border": {
            "info": "var(--colorCalloutBorderInfo)",
            "success": "var(--colorCalloutBorderSuccess)",
            "warning": "var(--colorCalloutBorderWarning)",
            "danger": "var(--colorCalloutBorderDanger)",
            "feature": "var(--colorCalloutBorderFeature)",
            "default": "var(--colorCalloutBorderDefault)",
            "upsell": "var(--colorCalloutBorderUpsell)"
        },
        "background": {
            "info": {
                "default": "var(--colorCalloutBackgroundInfoDefault)",
                "hover": "var(--colorCalloutBackgroundInfoHover)",
                "pressed": "var(--colorCalloutBackgroundInfoPressed)"
            },
            "success": {
                "default": "var(--colorCalloutBackgroundSuccessDefault)",
                "hover": "var(--colorCalloutBackgroundSuccessHover)",
                "pressed": "var(--colorCalloutBackgroundSuccessPressed)"
            },
            "attention": {
                "default": "var(--colorCalloutBackgroundAttentionDefault)",
                "hover": "var(--colorCalloutBackgroundAttentionHover)",
                "pressed": "var(--colorCalloutBackgroundAttentionPressed)"
            },
            "danger": {
                "default": "var(--colorCalloutBackgroundDangerDefault)",
                "hover": "var(--colorCalloutBackgroundDangerHover)",
                "pressed": "var(--colorCalloutBackgroundDangerPressed)"
            },
            "feature": {
                "default": "var(--colorCalloutBackgroundFeatureDefault)",
                "hover": "var(--colorCalloutBackgroundFeatureHover)",
                "pressed": "var(--colorCalloutBackgroundFeaturePressed)"
            },
            "default": {
                "hover": "var(--colorCalloutBackgroundDefaultHover)",
                "pressed": "var(--colorCalloutBackgroundDefaultPressed)"
            },
            "upsell": "var(--colorCalloutBackgroundUpsell)"
        }
    },
    "menuList": {
        "text": {
            "primary": "var(--colorMenuListTextPrimary)",
            "secondary": "var(--colorMenuListTextSecondary)",
            "highlight": "var(--colorMenuListTextHighlight)"
        },
        "background": {
            "default": "var(--colorMenuListBackgroundDefault)",
            "hover": "var(--colorMenuListBackgroundHover)",
            "active": "var(--colorMenuListBackgroundActive)"
        },
        "icon": {
            "primary": "var(--colorMenuListIconPrimary)"
        },
        "border": {
            "primary": "var(--colorMenuListBorderPrimary)"
        }
    },
    "textField": {
        "text": {
            "primary": "var(--colorTextFieldTextPrimary)",
            "secondary": "var(--colorTextFieldTextSecondary)",
            "selected": "var(--colorTextFieldTextSelected)",
            "danger": "var(--colorTextFieldTextDanger)",
            "disabled": "var(--colorTextFieldTextDisabled)"
        },
        "border": {
            "default": "var(--colorTextFieldBorderDefault)",
            "hover": "var(--colorTextFieldBorderHover)",
            "active": "var(--colorTextFieldBorderActive)",
            "danger": "var(--colorTextFieldBorderDanger)",
            "disabled": "var(--colorTextFieldBorderDisabled)"
        },
        "icon": {
            "primary": "var(--colorTextFieldIconPrimary)",
            "disabled": "var(--colorTextFieldIconDisabled)"
        }
    },
    "chip": {
        "filled": {
            "text": {
                "primary": "var(--colorChipFilledTextPrimary)",
                "secondary": "var(--colorChipFilledTextSecondary)",
                "info": "var(--colorChipFilledTextInfo)",
                "success": "var(--colorChipFilledTextSuccess)",
                "warning": "var(--colorChipFilledTextWarning)",
                "danger": "var(--colorChipFilledTextDanger)"
            },
            "background": {
                "primary": "var(--colorChipFilledBackgroundPrimary)",
                "secondary": "var(--colorChipFilledBackgroundSecondary)",
                "info": "var(--colorChipFilledBackgroundInfo)",
                "success": "var(--colorChipFilledBackgroundSuccess)",
                "warning": "var(--colorChipFilledBackgroundWarning)",
                "danger": "var(--colorChipFilledBackgroundDanger)"
            },
            "icon": {
                "primary": "var(--colorChipFilledIconPrimary)",
                "secondary": "var(--colorChipFilledIconSecondary)",
                "info": "var(--colorChipFilledIconInfo)",
                "success": "var(--colorChipFilledIconSuccess)",
                "warning": "var(--colorChipFilledIconWarning)",
                "danger": "var(--colorChipFilledIconDanger)"
            }
        },
        "outlined": {
            "border": {
                "primary": "var(--colorChipOutlinedBorderPrimary)",
                "secondary": "var(--colorChipOutlinedBorderSecondary)",
                "info": "var(--colorChipOutlinedBorderInfo)",
                "success": "var(--colorChipOutlinedBorderSuccess)",
                "warning": "var(--colorChipOutlinedBorderWarning)",
                "danger": "var(--colorChipOutlinedBorderDanger)"
            },
            "text": {
                "primary": "var(--colorChipOutlinedTextPrimary)",
                "secondary": "var(--colorChipOutlinedTextSecondary)",
                "info": "var(--colorChipOutlinedTextInfo)",
                "success": "var(--colorChipOutlinedTextSuccess)",
                "warning": "var(--colorChipOutlinedTextWarning)",
                "danger": "var(--colorChipOutlinedTextDanger)"
            },
            "icon": {
                "primary": "var(--colorChipOutlinedIconPrimary)",
                "secondary": "var(--colorChipOutlinedIconSecondary)",
                "info": "var(--colorChipOutlinedIconInfo)",
                "success": "var(--colorChipOutlinedIconSuccess)",
                "warning": "var(--colorChipOutlinedIconWarning)",
                "danger": "var(--colorChipOutlinedIconDanger)"
            }
        },
        "background": {
            "danger": "var(--colorChipBackgroundDanger)",
            "primary": "var(--colorChipBackgroundPrimary)",
            "secondary": "var(--colorChipBackgroundSecondary)",
            "successful": "var(--colorChipBackgroundSuccessful)"
        },
        "border": {
            "primary": "var(--colorChipBorderPrimary)"
        },
        "icon": {
            "inverse": "var(--colorChipIconInverse)",
            "primary": "var(--colorChipIconPrimary)",
            "warning": "var(--colorChipIconWarning)"
        },
        "text": {
            "inverse": "var(--colorChipTextInverse)",
            "primary": "var(--colorChipTextPrimary)"
        }
    },
    "button": {
        "background": {
            "primary": {
                "default": "var(--colorButtonBackgroundPrimaryDefault)",
                "hover": "var(--colorButtonBackgroundPrimaryHover)",
                "pressed": "var(--colorButtonBackgroundPrimaryPressed)"
            },
            "secondary": {
                "default": "var(--colorButtonBackgroundSecondaryDefault)",
                "hover": "var(--colorButtonBackgroundSecondaryHover)",
                "pressed": "var(--colorButtonBackgroundSecondaryPressed)"
            },
            "tertiary": {
                "default": "var(--colorButtonBackgroundTertiaryDefault)",
                "hover": "var(--colorButtonBackgroundTertiaryHover)",
                "pressed": "var(--colorButtonBackgroundTertiaryPressed)"
            },
            "destructive": {
                "default": "var(--colorButtonBackgroundDestructiveDefault)",
                "hover": "var(--colorButtonBackgroundDestructiveHover)",
                "pressed": "var(--colorButtonBackgroundDestructivePressed)"
            },
            "quiet": {
                "default": "var(--colorButtonBackgroundQuietDefault)",
                "hover": "var(--colorButtonBackgroundQuietHover)",
                "pressed": "var(--colorButtonBackgroundQuietPressed)"
            },
            "loud": {
                "default": "var(--colorButtonBackgroundLoudDefault)",
                "hover": "var(--colorButtonBackgroundLoudHover)",
                "pressed": "var(--colorButtonBackgroundLoudPressed)"
            },
            "neutral": {
                "default": "var(--colorButtonBackgroundNeutralDefault)",
                "hover": "var(--colorButtonBackgroundNeutralHover)",
                "pressed": "var(--colorButtonBackgroundNeutralPressed)"
            },
            "disabled": "var(--colorButtonBackgroundDisabled)"
        },
        "text": {
            "primary": "var(--colorButtonTextPrimary)",
            "secondary": "var(--colorButtonTextSecondary)",
            "tertiary": "var(--colorButtonTextTertiary)",
            "destructive": "var(--colorButtonTextDestructive)",
            "quiet": "var(--colorButtonTextQuiet)",
            "loud": "var(--colorButtonTextLoud)",
            "neutral": "var(--colorButtonTextNeutral)",
            "disabled": "var(--colorButtonTextDisabled)"
        },
        "border": {
            "secondary": "var(--colorButtonBorderSecondary)",
            "disabled": "var(--colorButtonBorderDisabled)"
        },
        "icon": {
            "primary": "var(--colorButtonIconPrimary)",
            "secondary": "var(--colorButtonIconSecondary)",
            "tertiary": "var(--colorButtonIconTertiary)",
            "quiet": "var(--colorButtonIconQuiet)",
            "loud": "var(--colorButtonIconLoud)",
            "neutral": "var(--colorButtonIconNeutral)",
            "disabled": "var(--colorButtonIconDisabled)",
            "destructive": "var(--colorButtonIconDestructive)"
        }
    },
    "dialog": {
        "background": {
            "primary": "var(--colorDialogBackgroundPrimary)",
            "secondary": {
                "default": "var(--colorDialogBackgroundSecondaryDefault)",
                "upsell": "var(--colorDialogBackgroundSecondaryUpsell)"
            }
        },
        "helpPanel": {
            "text": "var(--colorDialogHelpPanelText)"
        }
    },
    "progress": {
        "background": {
            "primary": "var(--colorProgressBackgroundPrimary)",
            "secondary": "var(--colorProgressBackgroundSecondary)"
        },
        "text": {
            "info": "var(--colorProgressTextInfo)"
        }
    },
    "progressBar": {
        "foreground": {
            "linear": "var(--colorProgressBarForegroundLinear)",
            "circular": "var(--colorProgressBarForegroundCircular)"
        },
        "background": {
            "linear": "var(--colorProgressBarBackgroundLinear)"
        }
    },
    "pagination": {
        "background": {
            "default": "var(--colorPaginationBackgroundDefault)",
            "hover": "var(--colorPaginationBackgroundHover)",
            "active": "var(--colorPaginationBackgroundActive)",
            "disabled": "var(--colorPaginationBackgroundDisabled)"
        },
        "text": {
            "default": "var(--colorPaginationTextDefault)",
            "hover": "var(--colorPaginationTextHover)",
            "active": "var(--colorPaginationTextActive)",
            "disabled": "var(--colorPaginationTextDisabled)"
        },
        "icon": {
            "default": "var(--colorPaginationIconDefault)",
            "hover": "var(--colorPaginationIconHover)",
            "active": "var(--colorPaginationIconActive)",
            "disabled": "var(--colorPaginationIconDisabled)"
        }
    },
    "switch": {
        "icon": {
            "active": "var(--colorSwitchIconActive)"
        },
        "overlay": {
            "on": "var(--colorSwitchOverlayOn)",
            "off": "var(--colorSwitchOverlayOff)"
        },
        "background": {
            "on": {
                "default": "var(--colorSwitchBackgroundOnDefault)",
                "disabled": "var(--colorSwitchBackgroundOnDisabled)"
            },
            "off": {
                "default": "var(--colorSwitchBackgroundOffDefault)",
                "disabled": "var(--colorSwitchBackgroundOffDisabled)"
            }
        },
        "foreground": {
            "on": {
                "default": "var(--colorSwitchForegroundOnDefault)",
                "disabled": "var(--colorSwitchForegroundOnDisabled)"
            },
            "off": {
                "default": "var(--colorSwitchForegroundOffDefault)",
                "disabled": "var(--colorSwitchForegroundOffDisabled)"
            }
        }
    },
    "text": {
        "primary": "var(--colorTextPrimary)",
        "secondary": "var(--colorTextSecondary)",
        "tertiary": "var(--colorTextTertiary)",
        "disabled": "var(--colorTextDisabled)",
        "inverse": {
            "primary": "var(--colorTextInversePrimary)",
            "secondary": "var(--colorTextInverseSecondary)"
        },
        "selected": "var(--colorTextSelected)",
        "info": "var(--colorTextInfo)",
        "success": "var(--colorTextSuccess)",
        "warning": "var(--colorTextWarning)",
        "danger": "var(--colorTextDanger)",
        "feature": "var(--colorTextFeature)",
        "link": {
            "default": "var(--colorTextLinkDefault)",
            "hover": "var(--colorTextLinkHover)"
        },
        "attention": "var(--colorTextAttention)"
    },
    "icon": {
        "primary": "var(--colorIconPrimary)",
        "secondary": "var(--colorIconSecondary)",
        "tertiary": "var(--colorIconTertiary)",
        "disabled": "var(--colorIconDisabled)",
        "inverse": {
            "primary": "var(--colorIconInversePrimary)",
            "secondary": "var(--colorIconInverseSecondary)"
        },
        "selected": "var(--colorIconSelected)",
        "info": "var(--colorIconInfo)",
        "success": "var(--colorIconSuccess)",
        "warning": "var(--colorIconWarning)",
        "attention": "var(--colorIconAttention)",
        "danger": "var(--colorIconDanger)",
        "feature": "var(--colorIconFeature)"
    },
    "border": {
        "primary": "var(--colorBorderPrimary)",
        "secondary": "var(--colorBorderSecondary)",
        "tertiary": "var(--colorBorderTertiary)",
        "disabled": "var(--colorBorderDisabled)",
        "selected": "var(--colorBorderSelected)",
        "info": "var(--colorBorderInfo)",
        "success": "var(--colorBorderSuccess)",
        "warning": "var(--colorBorderWarning)",
        "danger": "var(--colorBorderDanger)",
        "feature": "var(--colorBorderFeature)",
        "link": {
            "default": "var(--colorBorderLinkDefault)",
            "hover": "var(--colorBorderLinkHover)"
        },
        "attention": "var(--colorBorderAttention)",
        "bold": "var(--colorBorderBold)",
        "inverse": {
            "primary": "var(--colorBorderInversePrimary)",
            "secondary": "var(--colorBorderInverseSecondary)"
        },
        "default": "var(--colorBorderDefault)"
    },
    "background": {
        "primary": {
            "default": "var(--colorBackgroundPrimaryDefault)",
            "hover": "var(--colorBackgroundPrimaryHover)",
            "pressed": "var(--colorBackgroundPrimaryPressed)",
            "transparent": "var(--colorBackgroundPrimaryTransparent)"
        },
        "secondary": {
            "default": "var(--colorBackgroundSecondaryDefault)",
            "hover": "var(--colorBackgroundSecondaryHover)",
            "pressed": "var(--colorBackgroundSecondaryPressed)",
            "transparent": "var(--colorBackgroundSecondaryTransparent)"
        },
        "tertiary": "var(--colorBackgroundTertiary)",
        "disabled": "var(--colorBackgroundDisabled)",
        "inverse": {
            "primary": "var(--colorBackgroundInversePrimary)",
            "secondary": "var(--colorBackgroundInverseSecondary)",
            "neutral": "var(--colorBackgroundInverseNeutral)",
            "success": "var(--colorBackgroundInverseSuccess)"
        },
        "selected": "var(--colorBackgroundSelected)",
        "info": "var(--colorBackgroundInfo)",
        "success": "var(--colorBackgroundSuccess)",
        "warning": "var(--colorBackgroundWarning)",
        "danger": "var(--colorBackgroundDanger)",
        "feature": "var(--colorBackgroundFeature)",
        "supplementary": {
            "default": "var(--colorBackgroundSupplementaryDefault)"
        },
        "attention": "var(--colorBackgroundAttention)",
        "bold": "var(--colorBackgroundBold)",
        "quartary": {
            "default": "var(--colorBackgroundQuartaryDefault)",
            "hover": "var(--colorBackgroundQuartaryHover)",
            "pressed": "var(--colorBackgroundQuartaryPressed)"
        }
    },
    "carousel": {
        "text": {
            "primary": "var(--colorCarouselTextPrimary)"
        },
        "icon": {
            "default": "var(--colorCarouselIconDefault)",
            "hover": "var(--colorCarouselIconHover)",
            "selected": "var(--colorCarouselIconSelected)"
        },
        "background": {
            "primary": "var(--colorCarouselBackgroundPrimary)"
        }
    },
    "navList": {
        "text": {
            "default": "var(--colorNavListTextDefault)",
            "hover": "var(--colorNavListTextHover)",
            "active": "var(--colorNavListTextActive)"
        },
        "icon": {
            "default": "var(--colorNavListIconDefault)",
            "active": "var(--colorNavListIconActive)"
        },
        "background": {
            "default": "var(--colorNavListBackgroundDefault)",
            "hover": "var(--colorNavListBackgroundHover)",
            "active": "var(--colorNavListBackgroundActive)"
        }
    },
    "popover": {
        "background": {
            "primary": "var(--colorPopoverBackgroundPrimary)",
            "secondary": "var(--colorPopoverBackgroundSecondary)"
        }
    },
    "codeEditor": {
        "background": "var(--colorCodeEditorBackground)",
        "foreground": "var(--colorCodeEditorForeground)",
        "selection": "var(--colorCodeEditorSelection)",
        "selectionMatch": "var(--colorCodeEditorSelectionMatch)",
        "text": {
            "default": "var(--colorCodeEditorTextDefault)",
            "highlight": "var(--colorCodeEditorTextHighlight)",
            "hintHighlight": "var(--colorCodeEditorTextHintHighlight)",
            "gutter": "var(--colorCodeEditorTextGutter)"
        },
        "code": {
            "selectedBackground": "var(--colorCodeEditorCodeSelectedBackground)",
            "linenumberColor": "var(--colorCodeEditorCodeLinenumberColor)",
            "cursorBorderLeft": "var(--colorCodeEditorCodeCursorBorderLeft)",
            "cursorBorderRight": "var(--colorCodeEditorCodeCursorBorderRight)",
            "activelineBackground": "var(--colorCodeEditorCodeActivelineBackground)",
            "fatCursorBackground": "var(--colorCodeEditorCodeFatCursorBackground)",
            "atomNumberKeywordVariableAttributeQuoteColor": "var(--colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor)",
            "variableColor": "var(--colorCodeEditorCodeVariableColor)",
            "propertyColor": "var(--colorCodeEditorCodePropertyColor)",
            "punctuationUnitNegativeColor": "var(--colorCodeEditorCodePunctuationUnitNegativeColor)",
            "stringOperatorColor": "var(--colorCodeEditorCodeStringOperatorColor)",
            "positiveColor": "var(--colorCodeEditorCodePositiveColor)",
            "variable2Variable3String2UrlColor": "var(--colorCodeEditorCodeVariable2Variable3String2UrlColor)",
            "defTagBuiltinQualifierHeaderEmColor": "var(--colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor)",
            "bracketCommentColor": "var(--colorCodeEditorCodeBracketCommentColor)",
            "errorInvalidcharColor": "var(--colorCodeEditorCodeErrorInvalidcharColor)",
            "matchingbracketColor": "var(--colorCodeEditorCodeMatchingbracketColor)",
            "hintsBackground": "var(--colorCodeEditorCodeHintsBackground)",
            "hint": "var(--colorCodeEditorCodeHint)",
            "hintActiveBackground": "var(--colorCodeEditorCodeHintActiveBackground)",
            "syntax": {
                "tagName": "var(--colorCodeEditorCodeSyntaxTagName)",
                "comment": "var(--colorCodeEditorCodeSyntaxComment)",
                "bracket": "var(--colorCodeEditorCodeSyntaxBracket)",
                "className": "var(--colorCodeEditorCodeSyntaxClassName)",
                "propertyName": "var(--colorCodeEditorCodeSyntaxPropertyName)",
                "variableName": "var(--colorCodeEditorCodeSyntaxVariableName)",
                "attributeName": "var(--colorCodeEditorCodeSyntaxAttributeName)",
                "number": "var(--colorCodeEditorCodeSyntaxNumber)",
                "operator": "var(--colorCodeEditorCodeSyntaxOperator)",
                "keyword": "var(--colorCodeEditorCodeSyntaxKeyword)",
                "typeName": "var(--colorCodeEditorCodeSyntaxTypeName)",
                "typeOperator": "var(--colorCodeEditorCodeSyntaxTypeOperator)",
                "string": "var(--colorCodeEditorCodeSyntaxString)",
                "meta": "var(--colorCodeEditorCodeSyntaxMeta)",
                "regexp": "var(--colorCodeEditorCodeSyntaxRegexp)",
                "name": "var(--colorCodeEditorCodeSyntaxName)",
                "quote": "var(--colorCodeEditorCodeSyntaxQuote)",
                "heading": "var(--colorCodeEditorCodeSyntaxHeading)",
                "strong": "var(--colorCodeEditorCodeSyntaxStrong)",
                "emphasis": "var(--colorCodeEditorCodeSyntaxEmphasis)",
                "deleted": "var(--colorCodeEditorCodeSyntaxDeleted)",
                "deletedBackground": "var(--colorCodeEditorCodeSyntaxDeletedBackground)",
                "atom": "var(--colorCodeEditorCodeSyntaxAtom)",
                "bool": "var(--colorCodeEditorCodeSyntaxBool)",
                "specialVariableName": "var(--colorCodeEditorCodeSyntaxSpecialVariableName)",
                "url": "var(--colorCodeEditorCodeSyntaxUrl)",
                "escape": "var(--colorCodeEditorCodeSyntaxEscape)",
                "link": "var(--colorCodeEditorCodeSyntaxLink)",
                "invalid": "var(--colorCodeEditorCodeSyntaxInvalid)"
            },
            "indentationMarker": {
                "color": "var(--colorCodeEditorCodeIndentationMarkerColor)",
                "activeColor": "var(--colorCodeEditorCodeIndentationMarkerActiveColor)"
            }
        },
        "toolbar": {
            "background": "var(--colorCodeEditorToolbarBackground)",
            "button": {
                "hover": "var(--colorCodeEditorToolbarButtonHover)"
            }
        }
    },
    "scrollbar": {
        "background": "var(--colorScrollbarBackground)",
        "handle": "var(--colorScrollbarHandle)"
    },
    "categorySelectList": {
        "text": {
            "hover": "var(--colorCategorySelectListTextHover)",
            "active": "var(--colorCategorySelectListTextActive)"
        },
        "icon": {
            "default": "var(--colorCategorySelectListIconDefault)",
            "active": "var(--colorCategorySelectListIconActive)",
            "hover": "var(--colorCategorySelectListIconHover)"
        },
        "background": {
            "default": "var(--colorCategorySelectListBackgroundDefault)",
            "hover": "var(--colorCategorySelectListBackgroundHover)",
            "active": "var(--colorCategorySelectListBackgroundActive)"
        }
    },
    "spaceSwitcher": {
        "background": {
            "default": "var(--colorSpaceSwitcherBackgroundDefault)",
            "hover": "var(--colorSpaceSwitcherBackgroundHover)",
            "pressed": "var(--colorSpaceSwitcherBackgroundPressed)"
        },
        "text": {
            "default": "var(--colorSpaceSwitcherTextDefault)",
            "hover": "var(--colorSpaceSwitcherTextHover)",
            "pressed": "var(--colorSpaceSwitcherTextPressed)"
        },
        "icon": {
            "default": "var(--colorSpaceSwitcherIconDefault)"
        },
        "border": {
            "primary": "var(--colorSpaceSwitcherBorderPrimary)"
        }
    },
    "navTab": {
        "background": {
            "hover": "var(--colorNavTabBackgroundHover)",
            "active": "var(--colorNavTabBackgroundActive)"
        },
        "text": {
            "default": "var(--colorNavTabTextDefault)",
            "hover": "var(--colorNavTabTextHover)",
            "active": "var(--colorNavTabTextActive)"
        },
        "icon": {
            "default": "var(--colorNavTabIconDefault)",
            "hover": "var(--colorNavTabIconHover)",
            "active": "var(--colorNavTabIconActive)"
        },
        "border": {
            "primary": "var(--colorNavTabBorderPrimary)"
        }
    },
    "navButton": {
        "icon": {
            "default": "var(--colorNavButtonIconDefault)",
            "hover": "var(--colorNavButtonIconHover)",
            "pressed": "var(--colorNavButtonIconPressed)",
            "active": "var(--colorNavButtonIconActive)"
        },
        "background": {
            "default": "var(--colorNavButtonBackgroundDefault)",
            "hover": "var(--colorNavButtonBackgroundHover)",
            "pressed": "var(--colorNavButtonBackgroundPressed)",
            "active": "var(--colorNavButtonBackgroundActive)"
        }
    },
    "badge": {
        "background": {
            "neutral": "var(--colorBadgeBackgroundNeutral)",
            "inverseNeutral": "var(--colorBadgeBackgroundInverseNeutral)",
            "info": "var(--colorBadgeBackgroundInfo)",
            "success": "var(--colorBadgeBackgroundSuccess)",
            "warning": "var(--colorBadgeBackgroundWarning)",
            "danger": "var(--colorBadgeBackgroundDanger)",
            "feature": "var(--colorBadgeBackgroundFeature)"
        },
        "text": {
            "primary": "var(--colorBadgeTextPrimary)",
            "secondary": "var(--colorBadgeTextSecondary)",
            "feature": "var(--colorBadgeTextFeature)"
        },
        "icon": {
            "primary": "var(--colorBadgeIconPrimary)",
            "secondary": "var(--colorBadgeIconSecondary)",
            "feature": "var(--colorBadgeIconFeature)"
        }
    },
    "parallelChip": {
        "background": "var(--colorParallelChipBackground)",
        "icon": "var(--colorParallelChipIcon)"
    },
    "processWrapper": {
        "background": {
            "primary": "var(--colorProcessWrapperBackgroundPrimary)",
            "secondary": "var(--colorProcessWrapperBackgroundSecondary)"
        }
    },
    "processContainer": {
        "border": {
            "selected": "var(--colorProcessContainerBorderSelected)"
        },
        "background": {
            "selected": "var(--colorProcessContainerBackgroundSelected)"
        }
    },
    "processStep": {
        "background": {
            "primary": {
                "default": "var(--colorProcessStepBackgroundPrimaryDefault)",
                "selected": "var(--colorProcessStepBackgroundPrimarySelected)",
                "hover": "var(--colorProcessStepBackgroundPrimaryHover)"
            },
            "secondary": {
                "hover": "var(--colorProcessStepBackgroundSecondaryHover)",
                "default": "var(--colorProcessStepBackgroundSecondaryDefault)"
            },
            "tertiary": {
                "hover": "var(--colorProcessStepBackgroundTertiaryHover)"
            },
            "error": {
                "primary": "var(--colorProcessStepBackgroundErrorPrimary)",
                "hover": "var(--colorProcessStepBackgroundErrorHover)",
                "selected": "var(--colorProcessStepBackgroundErrorSelected)",
                "secondary": "var(--colorProcessStepBackgroundErrorSecondary)"
            },
            "warning": {
                "default": "var(--colorProcessStepBackgroundWarningDefault)",
                "hover": "var(--colorProcessStepBackgroundWarningHover)",
                "selected": "var(--colorProcessStepBackgroundWarningSelected)",
                "secondary": "var(--colorProcessStepBackgroundWarningSecondary)"
            }
        },
        "border": {
            "default": "var(--colorProcessStepBorderDefault)",
            "hover": "var(--colorProcessStepBorderHover)",
            "selected": "var(--colorProcessStepBorderSelected)",
            "disabled": "var(--colorProcessStepBorderDisabled)",
            "error": {
                "default": "var(--colorProcessStepBorderErrorDefault)",
                "hover": "var(--colorProcessStepBorderErrorHover)",
                "selected": "var(--colorProcessStepBorderErrorSelected)"
            },
            "warning": {
                "default": "var(--colorProcessStepBorderWarningDefault)",
                "hover": "var(--colorProcessStepBorderWarningHover)",
                "selected": "var(--colorProcessStepBorderWarningSelected)"
            }
        },
        "icon": {
            "default": "var(--colorProcessStepIconDefault)",
            "error": {
                "primary": "var(--colorProcessStepIconErrorPrimary)",
                "secondary": "var(--colorProcessStepIconErrorSecondary)"
            },
            "warning": {
                "primary": "var(--colorProcessStepIconWarningPrimary)",
                "secondary": "var(--colorProcessStepIconWarningSecondary)"
            }
        },
        "text": {
            "disabled": "var(--colorProcessStepTextDisabled)"
        }
    },
    "avatar": {
        "text": "var(--colorAvatarText)",
        "icon": {
            "primary": "var(--colorAvatarIconPrimary)",
            "secondary": "var(--colorAvatarIconSecondary)"
        },
        "background": {
            "image": {
                "default": "var(--colorAvatarBackgroundImageDefault)",
                "hover": "var(--colorAvatarBackgroundImageHover)"
            },
            "user": {
                "default": "var(--colorAvatarBackgroundUserDefault)",
                "hover": "var(--colorAvatarBackgroundUserHover)"
            },
            "space": {
                "default": "var(--colorAvatarBackgroundSpaceDefault)",
                "hover": "var(--colorAvatarBackgroundSpaceHover)"
            },
            "project": {
                "default": "var(--colorAvatarBackgroundProjectDefault)",
                "hover": "var(--colorAvatarBackgroundProjectHover)"
            },
            "tenant": {
                "default": "var(--colorAvatarBackgroundTenantDefault)",
                "hover": "var(--colorAvatarBackgroundTenantHover)"
            },
            "template": {
                "default": "var(--colorAvatarBackgroundTemplateDefault)",
                "hover": "var(--colorAvatarBackgroundTemplateHover)"
            }
        }
    },
    "avatarStack": {
        "background": {
            "hover": "var(--colorAvatarStackBackgroundHover)"
        }
    },
    "overlay": {
        "primary": "var(--colorOverlayPrimary)",
        "secondary": "var(--colorOverlaySecondary)"
    },
    "card": {
        "background": {
            "primary": {
                "default": "var(--colorCardBackgroundPrimaryDefault)"
            },
            "secondary": {
                "default": "var(--colorCardBackgroundSecondaryDefault)",
                "hover": "var(--colorCardBackgroundSecondaryHover)"
            }
        }
    },
    "lifecycle": {
        "text": {
            "primary": "var(--colorLifecycleTextPrimary)"
        },
        "border": {
            "default": "var(--colorLifecycleBorderDefault)"
        },
        "icon": {
            "default": "var(--colorLifecycleIconDefault)"
        },
        "background": {
            "primary": "var(--colorLifecycleBackgroundPrimary)"
        }
    },
    "tag": {
        "background": {
            "default": "var(--colorTagBackgroundDefault)",
            "hover": "var(--colorTagBackgroundHover)"
        }
    },
    "statusBadge": {
        "text": {
            "primary": "var(--colorStatusBadgeTextPrimary)",
            "inverse": "var(--colorStatusBadgeTextInverse)"
        },
        "icon": {
            "default": "var(--colorStatusBadgeIconDefault)",
            "inverse": "var(--colorStatusBadgeIconInverse)"
        },
        "background": {
            "healthy": "var(--colorStatusBadgeBackgroundHealthy)",
            "warning": "var(--colorStatusBadgeBackgroundWarning)",
            "unhealthy": "var(--colorStatusBadgeBackgroundUnhealthy)",
            "neutral": "var(--colorStatusBadgeBackgroundNeutral)"
        }
    },
    "taskStatus": {
        "icon": {
            "default": "var(--colorTaskStatusIconDefault)",
            "inverse": "var(--colorTaskStatusIconInverse)"
        },
        "background": {
            "success": "var(--colorTaskStatusBackgroundSuccess)",
            "executing": "var(--colorTaskStatusBackgroundExecuting)",
            "warning": "var(--colorTaskStatusBackgroundWarning)",
            "failure": "var(--colorTaskStatusBackgroundFailure)",
            "neutral": "var(--colorTaskStatusBackgroundNeutral)"
        }
    },
    "codeReview": {
        "text": {
            "danger": "var(--colorCodeReviewTextDanger)",
            "primary": "var(--colorCodeReviewTextPrimary)",
            "success": "var(--colorCodeReviewTextSuccess)"
        }
    },
    "portal": {
        "link": {
            "text": {
                "hover": "var(--colorPortalLinkTextHover)"
            }
        },
        "chip": {
            "background": "var(--colorPortalChipBackground)"
        },
        "popover": {
            "background": "var(--colorPortalPopoverBackground)"
        }
    }
} as const;
export const shadow = {
    "extraSmall": "var(--shadowExtraSmall)",
    "small": "var(--shadowSmall)",
    "medium": "var(--shadowMedium)",
    "large": "var(--shadowLarge)",
    "layoutPrimary": "var(--shadowLayoutPrimary)",
    "drawer": "var(--shadowDrawer)",
    "focused": "var(--shadowFocused)",
    "focusedInset": "var(--shadowFocusedInset)"
} as const;
